/**
 * TextEmptyValidator class is responsible for validating if a model's content is empty.
 * It provides methods to check for errors, retrieve error messages, and handle translations.
 */
class TextEmptyValidator {
    /**
     * Constructs a new TextEmptyValidator instance.
     * @param {Object} model - The model to be validated.
     * @param {Object} $injector - The injector used to get translation services.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.TEXT';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazily initializes and returns the translation service.
     * @returns {Object} The translation service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model's content and returns the validation result.
     * @param {string} from - The source from which the validation is triggered.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let isError = this.model.isContentEmpty();

        // If there's an error but no parents, consider it not an error.
        if (isError && this.model.getParents().length === 0) {
            isError = false;
        }

        return {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            isError,
            'status':           isError ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Retrieves the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if a forced check is required.
     * @returns {boolean} True if a forced check is required, otherwise false.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Returns the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'TextEmptyValidator';
    }
}

export default TextEmptyValidator;